import {actions} from 'react-fields'

class TopNotificationsApi {

    static getLayers(path) {
        let url = `/api/top_notifications?path=${encodeURIComponent(path)}`;
        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then((data) => {
                return data;
            })
    }

    static trackImpression(id) {
        const url = `/api/top_notifications/${id}/impression`;
        fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then((data) => {
                return data;
            }).catch(error => {
            console.log(error);
        })
    }

    static trackClick(id) {
        const url = `/api/top_notifications/${id}/click`;
        fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then((data) => {
                return data;
            }).catch(error => {
            console.log(error);
        })
    }

}

export default TopNotificationsApi;